import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
  activeScreensForTabs: {},
};

const navSlice = createSlice({
  name: 'nav',
  initialState: INITIAL_STATE,
  reducers: {
    setScreen: (state, action) => {
      const { activeScreen, activeTab } = action.payload;
      state.activeScreensForTabs[activeTab] = activeScreen || activeTab;
      return state;
    },
  },
});

export const { setScreen } = navSlice.actions;
export default navSlice.reducer;
